// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LSAQ","content":"styles_content__2WWs3"};